<script>
import { useResponseStore, useEventStore } from '../../../stores/index';
import DataDocument from './DataDocumentResp.vue';
import AttachmentDocument from './AttachmentDocumentResp.vue';
import UserSendDocument from './UserSendDocumentResp.vue';
import PreviewSend from './PreviewSendResp.vue';
import SignersDocument from './SignersDocumentResp.vue';
import Breadcrumb from '..//patchName.vue';
export default {
  name: 'DashboardDefault',
  components: { DataDocument, AttachmentDocument, UserSendDocument, PreviewSend, SignersDocument, Breadcrumb },
  setup () {
    const StoreAll = useResponseStore();
    const Events = useEventStore();
    return {
      Store: StoreAll,
      Events
    };
  },
  data () {
    return {
      componenteHeight: '93vh'
    };
  },
  mounted () {
    this.checkComponentHeight();
    window.addEventListener('resize', this.checkComponentHeight);
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.checkComponentHeight);
  },
  watch: {
  },
  methods: {
    checkComponentHeight () {
      const componente = document.getElementById('sendTo');
      const alturaViewport = window.innerHeight;

      if (componente.clientHeight < 0.93 * alturaViewport) {
        this.componenteHeight = '88vh';
      } else {
        this.componenteHeight = componente.clientHeight < 0.93 * alturaViewport + 'vh'; // Adaptar ao tamanho adicional
      }
    }
  }
};
</script>
<template>
  <div class='py-4 container-fluid'>
    <div class='row'>
      <div class='col-lg-12'>
        <div class='row'>
          <div class='d-flex justify-content-center'>
            <div class='col-12'>
              <Breadcrumb />
                <DataDocument v-if="this.Store.progress === 1" id="sendTo" :style="{ minHeight: componenteHeight }" />
                <AttachmentDocument v-if="this.Store.progress === 2" id="sendTo" :style="{ minHeight: componenteHeight }" />
                <UserSendDocument v-if="this.Store.progress === 3" id="sendTo" :style="{ minHeight: componenteHeight }" />
                <SignersDocument v-if="this.Store.progress === 4" id="sendTo" :style="{ minHeight: componenteHeight }" />
                <PreviewSend v-if="this.Store.progress === 5" id="sendTo" :style="{ minHeight: componenteHeight }" />
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
